// extracted by mini-css-extract-plugin
module.exports = {"root":"List-module__root___1ffts"};